import Link from 'gatsby-link';
import React from 'react';
import { Grid } from 'style';
import { DataStoreService } from 'utils';
import { Markdown, SideBySideTextMedia } from '../..';
import ListComponent, { ItemComponent, ListWrapper } from '../../common/lists/lists.component';

class JobsList extends ListComponent {
  constructor(props) {
    super(props);

    this.state = {
      jobs: null,
    };
  }

  componentDidMount() {
    this.setState(() => ({
      jobs: DataStoreService.getJobs(),
    }));
  }
  render() {
    const { jobs } = this.state;
    return jobs ? (
      <Grid.InnerContainer id="CaseList">
        {jobs.edges ?
          <ListWrapper id="wrapper">
            {jobs.edges.map(data => (
              <ItemComponent
                itemsPerRow={1}
                key={data.node.slug}
                onChange={this.onVisible}>
                <Link to={`/careers/${data.node.slug}`}>
                  <SideBySideTextMedia
                    text={`## ${data.node.title}
${data.node.intro || ''}`}
                    image={data.node.image}
                    textRight={false}
                  /></Link>
              </ItemComponent>
            ))}
          </ListWrapper>
          : <Markdown source={this.props.fallbackText} />}
      </Grid.InnerContainer>
    ) : (
        <div />
      );
  }
}

export default JobsList;
